<script>
  import Tailwind from "./Tailwind.svelte";
  import { onMount, onDestroy } from "svelte";
  export let duration;
  export let pause;
  let progressBar;
  let progressTotalLength;
  let progressDashoffset;
  let animation = null;
  let start = Date.now();
  let startPause;

  $: {
    if (duration === -1 && animation) {
      clearInterval(animation);
    } else {
      start = Date.now();
      animation = setInterval(interval, 1000 / 60);
    }
  }

  $: {
    if (pause) {
      startPause = Date.now();
    } else {
      start += Date.now() - startPause;
    }
  }

  onMount(() => {
    progressTotalLength = progressBar.getTotalLength();
    progressDashoffset = progressBar.getTotalLength();
    animation = setInterval(interval, 1000 / 60);

    return () => {
      clearInterval(animation);
    };
  });

  function interval() {
    if (!pause) {
      let timePassed = Date.now() - start;

      if (timePassed >= duration * 1000) {
        clearInterval(animation);
        progressDashoffset = 0;
        animation = null;
        return;
      }

      animateProgressBar(timePassed);
    }
  }

  function animateProgressBar(timePassed) {
    progressDashoffset =
      progressTotalLength -
      (progressTotalLength * ((timePassed / (duration * 1000)) * 100)) / 100;
  }

  onDestroy(() => {
    if (animation) {
      clearInterval(animation);
    }
  });
</script>

<svg
  class="w-full h-full"
  viewBox="0 0 24 24"
  version="1.1"
  id="svg8"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  xmlns="http://www.w3.org/2000/svg"
>
  <defs id="defs2">
    <linearGradient id="linearGradient3656">
      <stop offset="0" id="stop3652" stop-color="#b2b2b2" stop-opacity="1" />
      <stop offset="1" id="stop3654" stop-color="#f2f2f2" stop-opacity="1" />
    </linearGradient>
    <linearGradient id="linearGradient885">
      <stop offset="0" id="stop881" stop-color="#64ff92" stop-opacity="1" />
      <stop offset="1" id="stop883" stop-color="#68f2ff" stop-opacity="1" />
    </linearGradient>
    <linearGradient
      xlink:href="#linearGradient3656"
      id="linearGradient887"
      x1="-6"
      y1="12"
      x2="30"
      y2="12"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(.8 .8) scale(.93295)"
    />
    <linearGradient
      xlink:href="#linearGradient885"
      id="linearGradient3631"
      gradientUnits="userSpaceOnUse"
      x1="-6"
      y1="12"
      x2="30"
      y2="12"
      gradientTransform="translate(.8 .8) scale(.93295)"
    />
    <filter
      id="filter6895"
      x="-.07"
      y="-.07"
      width="1.13"
      height="1.15"
      color-interpolation-filters="sRGB"
    >
      <feGaussianBlur stdDeviation=".37" id="feGaussianBlur6897" />
    </filter>
  </defs>
  <g
    id="layer1"
    fill="none"
    fill-opacity="1"
    stroke-width="1"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-miterlimit="4"
    stroke-dasharray="none"
    stroke-opacity="0.1"
  >
    <path
      id="bg"
      d="M6.24 21.58A10.48 10.48 0 011.97 9.8a10.48 10.48 0 0110.1-7.44 10.48 10.48 0 0110 7.56 10.48 10.48 0 01-4.42 11.74"
      display="inline"
      stroke="url(#linearGradient887)"
    />
  </g>
  <g
    id="layer1"
    fill="none"
    fill-opacity="1"
    stroke-width="1"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-miterlimit="4"
    stroke-dasharray={progressTotalLength}
    stroke-dashoffset={progressDashoffset}
    stroke-opacity="1"
  >
    <path
      id="shadow"
      d="M6.24 21.58A10.48 10.48 0 011.97 9.8a10.48 10.48 0 0110.1-7.44 10.48 10.48 0 0110 7.56 10.48 10.48 0 01-4.42 11.74"
      display="inline"
      stroke="#97ffed"
      filter="url(#filter6895)"
    />
    <path
      bind:this={progressBar}
      id="progress"
      d="M6.24 21.58A10.48 10.48 0 011.97 9.8a10.48 10.48 0 0110.1-7.44 10.48 10.48 0 0110 7.56 10.48 10.48 0 01-4.42 11.74"
      display="inline"
      stroke="url(#linearGradient3631)"
    />
  </g>
</svg>
